<script>
  import userInfo from './login/user-info.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DefaultLayout',
    components: {
      userInfo,
    },
    computed: {
      ...mapGetters([
        'userId',
      ]),
    },
  }
</script>

<template lang="pug">

section.mainsection.hero.is-fullheight.is-dark
  .header
    .container.userinfowrapper
      nav.is-flex.mt2
        a.nav-iem.mr2(href='/')
          img._margin-icon(src="~@/assets/logo-noir.svg", width="80px")
        user-info.userinfo(:id="userId")
    .container.flex-auto
      nav.nav
        router-link.nav-item(active-class="is-active", :to="{ name: 'intro' }", exact) Chercher des suggestions
        router-link.nav-item(active-class="is-active", :to="{ name: 'new-ean13' }", exact) Ajouter un titre absent
  .hero-body
    .container
      slot

  .hero-foot
    .container
      .tabs.is-centered
        ul
          li
            a Copyright 2017 Robert veut lire
</template>

<style lang="postcss" scoped>


  .mainsection {
    & .userinfowrapper {
      margin-right: 20px;
    }
    & .header {
      display:flex;
      padding:20px;
    }
    & .nav-center {
      align-items: center;
    }
    & .headerc {
      height: 80px;
    }
    & .nav{
      padding-left:10em;
    }
    & .nav-item{
      padding-left:20px;
    }
  }
</style>



// WEBPACK FOOTER //
// default-layout.vue?3912fa9a